window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $('body'),

    // Navigation
    $navigation: $('#accessibleNav'),

    // Product Page
    $productImage: $('#productPhotoImg'),
    $popupImage: $('#fancyboxImg'),
    $thumbImages: $('#productThumbs').find('a.product-photo-thumb')
  }
};


timber.init = function () {
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.productImageSwitch();
  timber.popupImageSwitch();
  timber.responsiveVideos();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav--dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul');
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav--dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if ( !isSubItem ) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.productImageSwitch = function () {
  if ( timber.cache.$thumbImages.length ) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

timber.popupImageSwitch = function () {
if ( timber.cache.$thumbImages.length ) {
  // Switch the main image with one of the thumbnails
  // Note: this does not change the variant selected, just the image
  timber.cache.$thumbImages.on('click', function(evt) {
    evt.preventDefault();
    var newImage = $(this).attr('href');
    timber.switchPopup(newImage, null, timber.cache.$popupImage);
  });
}
};

timber.switchPopup = function (href, imgObject, el) {
// Make sure element is a jquery object
var $el = $(el);
$el.attr('href', href);
};

timber.responsiveVideos = function () {
  $('iframe[src*="youtube.com/embed"]').wrap('<div class="video-wrapper"></div>');
  $('iframe[src*="player.vimeo"]').wrap('<div class="video-wrapper"></div>');
};

// Initialize Timber's JS on docready
$(timber.init)

$(window).load(function(){
    
  function checkInputs(elm,check){

    var thisPrev = $(elm).prev();

    if(check) thisPrev.prop("checked", true);

    var optionIndex = thisPrev.closest('.swatch').attr('data-option-index');
    var optionValue = thisPrev.val();

    thisPrev.closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');

  }
  
  function openFancyboxCustom(array,idx){
	
    var fancyboxOverlayDisplay = $('.fancybox-overlay').css('display');
    
    $.fancybox.open(array,{
      'index' : idx,
      'openEffect' : 'none',
      'closeSpeed' : 555,
      'beforeShow' : function(){
        
        var fancyboxOverlay = $('.fancybox-overlay'),
            fancyboxWrap = $(this.wrap);
        
        if(fancyboxOverlayDisplay == 'block') fancyboxOverlay.append(fancyboxWrap);
        
        fancyboxOverlay.css({'opacity' : 1});
        fancyboxWrap.css({'transform' : 'scale(1)'});
      
      },
      'beforeClose' : function(){
        
        $('.fancybox-overlay').css({'opacity' : 0});
        $(this.wrap).css({'transform' : 'scale(0.9)'});
      
      }
    
    });

  }
        
  function initGallery(id,formid){
    
    if($('#' + id).find('a').length > 1){

      var productPhotoContainer = $('#' + id),
          productPhotoContainerParent = productPhotoContainer.parent(),
          addToCartForm = $('#' + formid),
          swatchElementInputs = addToCartForm.find('.swatch-color-inputs'),
          swatchElementInputsArray = [],
          productPhotoThumbs = productPhotoContainerParent.find('.product-photo-thumb'),
          productPhotoThumbsArray = [],
          APPUSH = Array.prototype.push,
          slide = 0,
          animationIsOn = 0,
          productPhotosArray = [];

      $.each(swatchElementInputs,function(index,item){

          APPUSH.call(swatchElementInputsArray,item);

      });

      $.each(productPhotoThumbs,function(index,item){

          APPUSH.call(productPhotoThumbsArray,item);

      });

      var replacedID = id.replace(/[^0-9]+/,''),
          productPhotoContainerCloned = productPhotoContainer.clone(true);

      productPhotoContainerParent.prepend('<div class="product-photo-container-wrapper" id="product-photo-container-wrapper-' + replacedID + '"></div>');

      var productPhotoContainerParent = $('#product-photo-container-wrapper-' + replacedID);

      productPhotoContainer.remove();

      productPhotoContainerParent.append(productPhotoContainerCloned);

      productPhotoContainerParent.append('<div title="Previous" class="custom-image-nav custom-image-nav-prev"><span></span></div><div title="Next" class="custom-image-nav custom-image-nav-next"><span></span></div>');

      productPhotoContainer = $('#productPhoto-' + replacedID);

      var productPhotoContainerImages = productPhotoContainer.find('.fancybox'),
          productPhotoContainerImagesLength = productPhotoContainerImages.length - 1;
 
      $.each(productPhotoContainer.find('a'),function(index,item){

        var item = $(item);

        APPUSH.call(productPhotosArray,{'href':item.attr('href'), 'rel':item.attr('rel'), 'class':item.attr('class'), 'src':item.find('img').attr('src'), 'alt':item.find('img').attr('alt')});

        index < 1 ? item.css({'display':'block'}).addClass('product-photo-active') : item.remove();

      });

      function setParentHeight(){

        productPhotoContainer.css({'height':parseFloat(productPhotoContainer.find('.product-photo-active').find('img').height()) + 'px'}); 

      }
      
      function attachFancyboxHandler(idx){
      
      	productPhotoContainer.find('.product-photo-active').on('click',function(){

          openFancyboxCustom(productPhotosArray,idx);
          
          return false;

        });
      
      }

      function initSlideChange(slideBefore,slide,dir){

        productPhotoContainer.find('a').not('.product-photo-active').remove();

        var productPhotosArrayCurrent = productPhotosArray[slide];

        productPhotoContainer[dir ? 'append' : 'prepend']('<a href="' + productPhotosArrayCurrent.href + '" rel="' + productPhotosArrayCurrent.rel + '" class="' + productPhotosArrayCurrent.class + '" style="left: ' + (dir ? '50%' : '-50%') + '"><img src="' + productPhotosArrayCurrent.src + '" alt="' + productPhotosArrayCurrent.alt + '"></a>');

        setTimeout(function(){

          productPhotoContainer.find('a').not('.product-photo-active').css({'left':'0'});

          productPhotoContainer.find('.product-photo-active').css({'left':dir ? '-50%' : '50%'}).one('transitionend',function(){

          $(this).removeClass('product-photo-active');
          productPhotoContainer.find('a')[dir ? 'last' : 'first']().addClass('product-photo-active');
          animationIsOn = 0;

          attachFancyboxHandler(slide);

          });

          swatchElementInputs.eq(slideBefore).prop("checked", false);
          swatchElementInputs.eq(slide).prop("checked", true);

        },20);

      }

      function changeImage(elm,array){

        if(!animationIsOn){

          animationIsOn = 1;

          var slideBefore = slide;

          slide = $.inArray(elm,array);

          if(slide != slideBefore){

            initSlideChange(slideBefore,slide,slide > slideBefore ? 1 : 0);

            }else animationIsOn = 0;

          }

      }
      
      setParentHeight();

      $(window).on('resize',function(){

        setParentHeight();

      });

      productPhotoContainerParent.find('.custom-image-nav-prev').click(function(){

        if(!animationIsOn){

          animationIsOn = 1;

          var slideBefore = slide;

          slide--;

          if(slide < 0) slide = productPhotoContainerImagesLength;

          initSlideChange(slideBefore,slide,0); 

          }

      });

      productPhotoContainerParent.find('.custom-image-nav-next').click(function(){

        if(!animationIsOn){

         animationIsOn = 1;

          var slideBefore = slide;

          slide++;

          if(slide > productPhotoContainerImagesLength) slide = 0;

          initSlideChange(slideBefore,slide,1); 

          }    

      });

      swatchElementInputs.click(function(){

        changeImage(this,swatchElementInputsArray);
        
        checkInputs(this,false);

      });

      productPhotoThumbs.click(function(){
        
        changeImage(this,productPhotoThumbsArray);
		
        return false;
        
      });
      
      attachFancyboxHandler(slide);
      
    }
    
  }
    
  for(var i = 0, addToCartForms = document.getElementsByClassName('add-to-cart-form'); i < addToCartForms.length; i++){ 
  	
    (function(idx){
         	
      var addToCartForm = $(addToCartForms[i]),
          swatchElementInputsSize = addToCartForm.find('.swatch-size-inputs'),
          productPhotoContainer = addToCartForm.parent().parent().prev(),
          productPhotoContainerImages = productPhotoContainer.find('.fancybox');
      
      swatchElementInputsSize.click(function(){
      
        $.each(swatchElementInputsSize,function(index,item){
        
          $(item).prev().prop("checked", false);        
        
        });
        
        checkInputs(this,true);
        
      });
      
      if(productPhotoContainerImages.length == 1){

        productPhotoContainerImages.on('click',function(){
		  
          openFancyboxCustom([{'href' : productPhotoContainerImages.attr('href')}],0);
                  
          return false;

          });
        
      	}
      
    })(i);
    
  }
  
  for(var i = 0, productPhotoContainers = document.getElementsByClassName('product-photo-container'), addToCartForms = document.getElementsByClassName('add-to-cart-form'); i < productPhotoContainers.length; i++){ 
  
    initGallery(productPhotoContainers[i].id,addToCartForms[i].getAttribute('id'));
    
  }
  

  $(document).on('click', '#terms', function(){
    $('#cartContent').hide();
    $('#termsDescription').removeClass('hidden');
  });

  $(document).on('click', '#backToCart, .CartToggle', function(){
    $('#termsDescription').addClass('hidden');
    $('#cartContent').show();
  });

});